/** ポーリング間隔（ms） */
export const POLLING_INTERVAL_MS = 2000;

/** デフォルトで選択するデータソース */
export const DEFAULT_SELECTED_SOURCES = ['basic_info', 'custom_data', 'document'];
